import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner1-1920x450.jpg";

import MainImg from "../assets/Images/welcome.png";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import "./WelcomeMessagePage.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const WelcomeMessagePage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("welcome_page_heading")}</h1>
          <p className="banner-subtitle">{t("welcome_page_heading2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_welcome_page_link1")}</Link>
        <span>{t("breadcrumbs_welcome_page_span")}</span>
        <Link>{t("breadcrumbs_welcome_page_link2")}</Link>
      </Breadcrumbs>
      <main className="welcome-main-container">
        <div className="welcome-image-section">
          <img className="welcome-image" src={MainImg} alt="Welcome message" />
        </div>
        <section className="welcome-content-section">
          <div className="welcome-text-container">
            <p>{t("welcome_page_p1")}</p>
            <p>{t("welcome_page_p2")}</p>
            <p>{t("welcome_page_p3")}</p>
            <p>{t("welcome_page_p4")}</p>
            <p>{t("welcome_page_p5")}</p>
            <p>{t("welcome_page_p6")}</p>
            <p>{t("welcome_page_p7")}</p>
          </div>
        </section>
        <div className="temporary">
          <img src={BottomLogoImg} alt="" />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default WelcomeMessagePage;
